import { TextBox } from "./textBox.js";
import { ComponentHelper } from "../util/componentHelper.js";
import { Helper } from "../util/helper.js";
import { Config } from "../config/config.js";
import { Dialog, DialogProps } from "./dialog.js";
import { FieldInstance } from "./field.js";
import { MultiSelect, MultiSelectProps } from "./multiSelect.js";
import { FullHeightContainer } from "./FullHeighContainer.js";
import { HTTPService } from "../util/httpManager.js";
import { DropDownList, DropDownListProps } from "./dropDownList.js";
import { BaseComponentProps } from "./baseComponentProps.js";
import { StringKeyDictionary } from "../../commonInterfaces.js";
import React from "react";

export class TranslationTextBox extends React.Component<TranslationTextBoxProps, TranslationTextBoxState>{
    private _userLanguage: number = null;
    private _factory = ComponentHelper.createFactory();
    private _translations: StringKeyDictionary<string> = null;
    constructor(props: TranslationTextBoxProps) {
        super(props)
        let values: TranslationTextBoxValue[] = [];
        this._loadTranslations();
        if (Helper.hasValue(props.value) && props.value.length > 0) {
            values = props.value.map((value: any) => {
                let item: TranslationTextBoxValue = {
                    language: value[props.language],
                    translation: Helper.getValueOrDefault(value[props.translation], "")
                };
                return item;
            });
        } else {
            this._loadDefaultTranslations();
        }
        this.state = {
            values: values
        }
        this._userLanguage = Config.user.languageId;
    }

    private _loadDefaultTranslations = () => {
        HTTPService.get("TranslationsView/GetDefaultTranslations")
            .then(result => {
                this.setState({ values: result });
            });
    }
    private _loadTranslations = () => {
        Helper.getTranslations(["WebSMS.GeneralSettings.UebersetzungenBearbeiten", "WebSMS.Resource.Sprachen"])
            .then((result) => {
                this._translations = result.Data;
                this.setState({ translationLoaded: true });
            });
    }
    private _createTextBox = () => {
        let props = this._factory.getDefaultTextBoxProps();
        let value = this.state.values.find(f => f.language == this._userLanguage)?.translation ?? "";
        props.value = value;
        props.field.multiLine = this.props.multiLine;
        props.field.maxLength = this.props.maxLength;
        props.disabled = this.props.disabled;
        props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
            let values = this.state.values;
            let index = values.indexOf(values.find(f => f.language == this._userLanguage));
            values[index].translation = value;
            this.setState({ values: values }, () => { this._handleChange(value) });
        }
        return (<TextBox {...props} />)
    }
    private _createLink = () => {
        const labelStyle: React.CSSProperties = {
            cursor: "pointer",
            textDecoration: "Underline"
        }
        const divStyle: React.CSSProperties = {
            display: "flex",
            justifyContent: "flex-end",
            fontSize: "10px",
            marginTop: "2px"

        }
        return (
            <>
                <div style={divStyle}>
                    <label style={labelStyle} onClick={this.onLinkClick}>{this._translations["WebSMS.GeneralSettings.UebersetzungenBearbeiten"]}</label>
                </div>
            </>
        );
    }
    private _handleChange = (value: string = null) => {
        let lst = this.state.values.map((v: TranslationTextBoxValue) => {
            let item = {};
            item[this.props.language] = v.language;
            item[this.props.translation] = v.translation;
            return item;
        });
        this.props.onChange(this.props.field, lst);
    }

    private _onClick = (values: Array<TranslationTextBoxValue>) => {
        this.setState({ dialogOpen: false, values: values }, () => { this._handleChange() });
    }

    private _onCloseClick = (values: Array<TranslationTextBoxValue>) => {
        this.setState({ dialogOpen: false });
    }

    private _onDialogTextBoxChange = (value: string) => {
        this._handleChange(value);
    }
    onLinkClick = () => {
        this.setState({ dialogOpen: true });
    }
    render() {
        const dialoge = this.state.dialogOpen ? <TranslationTextBoxDialog
            values={this.state.values}
            onOkClick={this._onClick}
            onCloseClick={this._onCloseClick}
            onChange={this._onDialogTextBoxChange}
            multiLine={this.props.multiLine}
            translations={this._translations}
        /> : null;
        const link = this.state.translationLoaded && !this.props.disabled ? this._createLink() : null;
        let element: JSX.Element = null;
        if (Helper.hasValue(this.state.values)) {
            element = (<>
                {this._createTextBox()}
                {link}
                {dialoge}
            </>);
        } else {
            element = (<></>);
        }

        return element;
    }
}

class TranslationTextBoxDialog extends React.Component<TranslationTextBoxDialogProps, TranslationTextBoxDialogState> {
    private _LOCAL_STORAGE_KEY = "EditTranslations_Translations_" + Config.user.languageId.toString();
    private _factory = ComponentHelper.createFactory();
    private _translations: StringKeyDictionary<string> = null;
    private _currentLanguageSelection: Array<{ Language: number, Sprache: string }> = [];
    private initalValues: Array<TranslationTextBoxValue> = null;
    private _dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => {
                    this.props.onCloseClick(null);

                }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this.props.onOkClick(this.initalValues);
                },
                primary: true
            }
        ],
        width: 500

    };

    constructor(props: TranslationTextBoxDialogProps) {
        super(props);
        this._translations = props.translations;
        let ls: Array<{ Language: number, Sprache: string }> = Helper.loadDataFromStorage(this._LOCAL_STORAGE_KEY);
        if (ls !== undefined) {

            if (this.props.multiLine) {
                this._currentLanguageSelection = ls.length > 0 ? [ls[0]] : [];
            } else {
                this._currentLanguageSelection = ls;
            }
        }
        this.initalValues = JSON.parse(JSON.stringify(props.values));
        this.state = {
            values: this.initalValues
        }
    }


    private _createDialog = () => {
        return (
            <Dialog {...this._dialogProps} open={true}>
                <FullHeightContainer>
                    {this.props.multiLine ? this._createDropDown() : this._createMultiSelect()}
                    {this._createTextBoxes()}
                </FullHeightContainer>
            </Dialog>
        );
    }

    private _createMultiSelect = () => {
        let props: MultiSelectProps = this._factory.getDefaultMultiSelectProps();
        props.value = this._currentLanguageSelection;
        props.field.dataSourceUrl = "TranslationsView/GetLanguages";
        props.field.dataValueField = "Language";
        props.field.dataTextField = "Sprache";
        props.onChange = (field: { model: string }, value) => {
            this._currentLanguageSelection = value;
            Helper.saveDataToStorage(this._LOCAL_STORAGE_KEY, value, false);
            this.setState({})
        };
        return (
            <FieldInstance label={this._translations["WebSMS.Resource.Sprachen"]} noHover={true} >
                <MultiSelect {...props} />
            </FieldInstance>
        );
    }

    private _createDropDown = () => {
        let props: DropDownListProps = this._factory.getDefaultDropDownProps();
        props.field.dataSourceUrl = "TranslationsView/GetLanguages";
        props.field.dataValueField = "Language";
        props.field.dataTextField = "Sprache";
        props.value = this._currentLanguageSelection.length > 0 ? this._currentLanguageSelection[0].Language : null;
        props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
            this._currentLanguageSelection = [{
                Language: dataItem.Language,
                Sprache: dataItem.Sprache
            }];
            Helper.saveDataToStorage(this._LOCAL_STORAGE_KEY, this._currentLanguageSelection, false);
            this.setState({});
        }
        return (
            <FieldInstance label={this._translations["WebSMS.Resource.Sprachen"]} noHover={true} >
                <DropDownList {...props} />
            </FieldInstance>
        );
    }

    private _createTextBoxes = () => {
        let elemets = this._currentLanguageSelection.map((language: { Language: number, Sprache: string }) => {
            return (
                <div key={language.Language} style={{ flexShrink: 0 }}>
                    <FieldInstance label={language.Sprache} noHover={true} >
                        <TextBox {...this._createTextBoxProps(language)} />
                    </FieldInstance>
                </div>
            );
        });

        return elemets;
    }

    private _createTextBoxProps = (language: { Language: number, Sprache: string }) => {
        let props = this._factory.getDefaultTextBoxProps();
        props.field.name = language.Sprache;
        props.field.multiLine = this.props.multiLine;
        props.field.maxLength = this.props.maxLength;
        props.onChange = this.handleTextBoxesChances;
        props.value = Helper.getValueOrDefault(this.initalValues.find(f => f.language == language.Language)?.translation, "");
        return (props);
    }

    handleTextBoxesChances = (field: { model: string, name: string }, value: any) => {
        let id = this._currentLanguageSelection.find(f => f.Sprache == field.name).Language;
        let values = this.initalValues;
        let item = values.find(f => f.language == id);
        let index = values.indexOf(item);
        values[index].translation = value;
        this.props.onChange(value);
        this.setState({ values: values });
    }

    render() {
        const dialog = this._createDialog();

        return (
            <>
                {dialog}
            </>
        );
    };
}

interface TranslationTextBoxState {
    values: Array<TranslationTextBoxValue>;
    dialogOpen?: boolean;
    translationLoaded?: boolean;
}

interface TranslationTextBoxDialogProps {
    values: Array<TranslationTextBoxValue>;
    onOkClick: (values: Array<TranslationTextBoxValue>) => void;
    onCloseClick: (values: Array<TranslationTextBoxValue>) => void;
    onChange: (value: string) => void;
    multiLine: boolean;
    maxLength?: number;
    translations?: StringKeyDictionary<string>
}

interface TranslationTextBoxDialogState {
    values: Array<TranslationTextBoxValue>;
}

interface TranslationTextBoxValue {
    language: number;
    translation: string;
}

export interface TranslationTextBoxProps extends BaseComponentProps {
    value: Array<any>;
    multiLine: boolean;
    maxLength?: number;
    language: string;
    translation: string;
}